module.exports = __webpack_public_path__ + "static/media/folderindex-document-large.722a1da5.svg";